import bwSmileBad from 'assets/icons/csat-icons/bw-smile-bad.svg';
import bwSmileExcellent from 'assets/icons/csat-icons/bw-smile-excellent.svg';
import bwSmileGood from 'assets/icons/csat-icons/bw-smile-good.svg';
import bwSmileOkay from 'assets/icons/csat-icons/bw-smile-okay.svg';
import bwSmileTerrible from 'assets/icons/csat-icons/bw-smile-terrible.svg';
import smileBad from 'assets/icons/csat-icons/smile-bad.svg';
import smileExcellent from 'assets/icons/csat-icons/smile-excellent.svg';
import smileGood from 'assets/icons/csat-icons/smile-good.svg';
import smileOkay from 'assets/icons/csat-icons/smile-okay.svg';
import smileTerrible from 'assets/icons/csat-icons/smile-terrible.svg';
import star from 'assets/icons/csat-icons/star.svg';
import emptyStar from 'assets/icons/csat-icons/empty-star.svg';
import type { StyleOption } from './type';

export const csatOneToFiveOptions: StyleOption[] = [
  {
    icon: star,
    iconNames: ['Terrible', 'Bad', 'Okay', 'Good', 'Excellent'],
    icons: [emptyStar, emptyStar, emptyStar, emptyStar, emptyStar],
    label: 'Stars',
    selectedIcon: star,
    value: 'star',
  },
  {
    icon: smileExcellent,
    iconNames: ['Terrible', 'Bad', 'Okay', 'Good', 'Excellent'],
    icons: [smileTerrible, smileBad, smileOkay, smileGood, smileExcellent],
    label: 'Smiles',
    value: 'smile',
  },
  {
    icon: bwSmileExcellent,
    iconNames: ['Terrible', 'Bad', 'Okay', 'Good', 'Excellent'],
    icons: [
      bwSmileTerrible,
      bwSmileBad,
      bwSmileOkay,
      bwSmileGood,
      bwSmileExcellent,
    ],
    label: 'BW smiles',
    value: 'bw_smile',
  },
];

// 1-3 is low rating, 4-5 is high rating
export const LOW_RATING_CAP = 3;

// Csat Stages
export const RATING_STAGE = 0;
export const HIGH_RATING_REASONS_STAGE = 1;
export const LOW_RATING_REASONS_STAGE = 2;
export const RESOLUTION_CONFIRMATION_STAGE = 3;
export const ADDITIONAL_FEEDBACK_STAGE = 4;
export const SUBMIT_STAGE = 5;
